import { useState } from "react";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { PageHero } from "@/components/PageHero";
import { WeeklyTimetable } from "@/components/WeeklyTimetable";
import { BookingModal } from "@/components/BookingModal";
import { RelatedLinks } from "@/components/RelatedLinks";
import { usePageMeta } from "@/hooks/usePageMeta";
import { useCampaign } from "@/hooks/useCampaign";
import { SITE } from "@/data/site";

export default function SchedulePage() {
  const [openFull, setOpenFull] = useState(false);
  useCampaign();

  usePageMeta(
    "Find a Class · USDD Academy",
    "USDD Academy's weekly class schedule across London & Kent. Kids, adult and workshop classes — reserve your spot in seconds."
  );
  return (
    <>
      <Header />
      <main>
        <PageHero
          overline="Find a Class · Book Online"
          title="Pick a class."
          highlight="Lock it in."
          description="Our cinematic weekly schedule of street dance classes across London & Kent — kids, adults and workshops, all bookable through a clean focused flow."
          ctaPrimary={{ label: "Open booking", to: "/schedule#timetable" }}
          ctaSecondary={{ label: "See pricing", to: "/pricing" }}
          bg={SITE.classImg2}
        />

        <section id="timetable" data-testid="schedule-timetable-section" className="py-16 sm:py-24 bg-black scroll-mt-24">
          <div className="max-w-6xl mx-auto px-6 sm:px-8">
            <WeeklyTimetable variant="full" defaultFilter="all" />
            <div className="mt-8 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 p-6 rounded-2xl bg-white/[0.03] border border-white/10">
              <div>
                <div className="text-[10px] uppercase tracking-[0.3em] text-brand-yellow mb-1">One-off / specific date?</div>
                <div className="font-display text-2xl text-white tracking-wide">Open the full booking engine.</div>
              </div>
              <button
                type="button"
                onClick={() => setOpenFull(true)}
                data-testid="schedule-open-modal-btn"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-brand-yellow text-black font-black uppercase text-xs tracking-[0.2em] hover:bg-brand-yellowHover hover:scale-[1.02] transition-all glow-yellow"
              >
                Open booking
              </button>
            </div>
          </div>
        </section>

        <RelatedLinks
          title="While you're here"
          items={[
            { tag: "Pricing", label: "Browse prices", desc: "Drop-ins, terms and memberships", to: "/pricing" },
            { tag: "Kids", label: "USDD Kids", desc: "Junior programme ages 6–17", to: "/kids" },
            { tag: "Workshops", label: "Monthly workshops", desc: "Cultural & social gatherings", to: "/workshops" },
          ]}
        />
      </main>
      <Footer />

      <BookingModal
        open={openFull}
        onClose={() => setOpenFull(false)}
        title="Reserve a class"
        subtitle="Full live schedule · Powered by Acuity"
      />
    </>
  );
}
